<template>
  <div class="p-24">
    <RevIllustration
      alt=""
      aria-hidden="true"
      class="rounded-md block aspect-[3/2] h-[218px] w-full max-w-[498px] object-cover"
      :height="498"
      src="/img/product/funnel/step-processor.jpg"
      :width="498"
    />
    <section class="mt-32">
      <h3 class="heading-1">{{ i18n(translations.heading) }}</h3>
      <p class="body-1 pt-8">{{ i18n(translations.intro) }}</p>
    </section>
    <section class="mt-32">
      <h3 class="heading-2">{{ i18n(translations.section1Title) }}</h3>
      <div class="mt-16 flex gap-16">
        <IconKeyboard class="shrink-0" height="24" width="24" />
        <div>
          <h4 class="body-1-bold">
            {{ i18n(translations.section1Item1Title) }}
          </h4>
          <p class="body-2 text-static-default-low pt-8">
            {{ i18n(translations.section1Item1Description) }}
          </p>
        </div>
      </div>
      <div class="mt-24 flex gap-16">
        <IconCardView class="shrink-0" height="24" width="24" />
        <div>
          <h4 class="body-1-bold">
            {{ i18n(translations.section1Item2Title) }}
          </h4>
          <p class="body-2 text-static-default-low pt-8">
            {{ i18n(translations.section1Item2Description) }}
          </p>
        </div>
      </div>
      <div class="mt-24 flex gap-16">
        <IconController class="shrink-0" height="24" width="24" />
        <div>
          <h4 class="body-1-bold">
            {{ i18n(translations.section1Item3Title) }}
          </h4>
          <p class="body-2 text-static-default-low pt-8">
            {{ i18n(translations.section1Item3Description) }}
          </p>
        </div>
      </div>
    </section>
    <RevDivider class="my-32" />
    <section>
      <h3 class="heading-2">{{ i18n(translations.section2Title) }}</h3>
      <ProcessorImage class="mt-24" />
      <div class="mt-24">
        <h4 class="body-1-bold">
          {{ i18n(translations.section2Subtitle1) }}
        </h4>
        <p class="body-2 text-static-default-low pt-8">
          {{ i18n(translations.section2Subtitle1Description) }}
        </p>
      </div>
      <div class="mt-24">
        <h4 class="body-1-bold">
          {{ i18n(translations.section2Subtitle2) }}
        </h4>
        <p class="body-2 text-static-default-low pt-8">
          {{ i18n(translations.section2Subtitle2Description) }}
        </p>
      </div>
      <div class="mt-24">
        <h4 class="body-1-bold">{{ i18n(translations.section2Subtitle3) }}</h4>
        <div class="mt-8">
          <p class="body-1-bold bg-static-default-mid rounded-xs w-fit px-4">
            {{ i18n(translations.section2Subtitle3Title1) }}
          </p>
          <p class="body-2 text-static-default-low pt-8">
            {{ i18n(translations.section2Subtitle3Title1Description) }}
          </p>
        </div>
        <div class="mt-8">
          <p class="body-1-bold bg-static-default-mid rounded-xs w-fit px-4">
            {{ i18n(translations.section2Subtitle3Title2) }}
          </p>
          <p class="body-2 text-static-default-low pt-8">
            {{ i18n(translations.section2Subtitle3Title2Description) }}
          </p>
        </div>
        <div class="mt-8">
          <p class="body-1-bold bg-static-default-mid rounded-xs w-fit px-4">
            {{ i18n(translations.section2Subtitle3Title3) }}
          </p>
          <p class="body-2 text-static-default-low pt-8">
            {{ i18n(translations.section2Subtitle3Title3Description) }}
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDivider } from '@ds/components/Divider'
import { RevIllustration } from '@ds/components/Illustration'
import { IconCardView } from '@ds/icons/IconCardView'
import { IconController } from '@ds/icons/IconController'
import { IconKeyboard } from '@ds/icons/IconKeyboard'

import ProcessorImage from '../ProcessorImage/ProcessorImage.vue'

import translations from './LaptopProcessorModalBody.translations'

const i18n = useI18n()
</script>
